import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { ButtonBar } from 'components';
import { Field } from 'formik';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;

    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n70};
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-bottom: 8px;
    margin-top: 24px;
`;

export const TwoFactorChoice = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;

export const QRCodeImage = styled.img`
  width: 100px;
`

export const FormField = styled(Field)`
    padding: 0 16px;
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
`;

export const InvalidErrorMessage = styled.div`
    margin-top: 4px;
    color: ${Variables.Colors.warning};
`;
